export enum AuthStatus {
  PENDING = 'PENDING',
  NO_AUTH = 'NO_AUTH',
  AUTHORIZED = 'AUTHORIZED',
}

export enum departments {
  Development = 'Разработка',
  ProjectOffice = 'Клиентский сервис',
}

export const engDepartments = {
  [departments.Development]: 'developer',
  [departments.ProjectOffice]: 'manager',
}

export interface User {
  _id: string
  name: string
  firstName: string
  lastName: string
  department: departments
}
